export { InventoryPanelWrapper as InventoryPanel } from './InventoryPanelWrapper'